module.exports = __webpack_public_path__ + "static/media/23.17e89c6e.jpg";